import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

/**
 * useAndroidBackButton — Intercepta o botão de voltar do Android no Capacitor.
 *
 * Comportamento:
 * - Se há histórico de navegação: volta para a página anterior (history.back)
 * - Se está na Home (/): minimiza o app ao invés de fechar
 */
export function useAndroidBackButton(): void {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const listener = App.addListener('backButton', ({ canGoBack }) => {
      // Se está na Home, minimiza o app
      if (location.pathname === '/') {
        App.minimizeApp();
        return;
      }

      // Se há histórico, volta
      if (canGoBack) {
        navigate(-1);
      } else {
        // Sem histórico mas não está na home — vai para home
        navigate('/', { replace: true });
      }
    });

    return () => {
      listener.then((l) => l.remove());
    };
  }, [location.pathname, navigate]);
}
